import React, { lazy, useState } from 'react';

// ページごとに JavaScript を分けて読む（React.lazy）。最初に開いたページの分は、src/index.js が描く前に preload() で
// 読み込む。読み込み済みなら待ち（Suspense）を挟まずにそのまま描くので、ビルド時に書き出した HTML が一瞬消えることがない。
export default function lazyPage(load) {
  let Loaded = null;
  const preload = () =>
    load().then((m) => {
      Loaded = m.default;
      return m;
    });
  const Lazy = lazy(preload);
  // 描き始めた時点で決めて、途中で入れ替えない（入れ替えると、ページが作り直されて状態が消える）
  const Page = (props) => {
    const [Component] = useState(() => Loaded || Lazy);
    return <Component {...props} />;
  };
  Page.preload = preload;
  return Page;
}
